// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionContentHOC-container","header":"SectionContentHOC-header","collapsed":"SectionContentHOC-collapsed","sectionTitle":"SectionContentHOC-sectionTitle"};